import React, { useState, useEffect, useCallback } from "react";
import { Box, Button, Typography, TextareaAutosize, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Select, MenuItem, FormControl, FormLabel, Autocomplete } from "@mui/material";
import Grid from '@mui/material/Grid2';
import { useDispatch, useSelector } from "react-redux";
import { addTemplate, updateTemplate, fetchTemplatesById } from "../../redux/Slice/showcase/templateSlice"; // Import fetchTemplateById
import { fetchTags, addTag,updateTag } from "../../redux/Slice/showcase/tagSlice";
import { toast } from "sonner";
import { clearMessage } from "../../redux/Slice/message";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import { setLoading } from "../../redux/Slice/loaderSlice";
import RunCodeEditor from "../../components/codeditor/CodeEditor";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getQuoteByServiceId,getQuote} from "../../redux/Slice/quoteSlice";
import { fetchService } from "../../redux/Slice/serviceslice";

const CodeEditor = () => {

  const { state } = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();  
  
  const isEditing = state?.name === "edit";
  const [dialogOpen, setDialogOpen] = useState(false);
  const [newTag, setNewTag] = useState("");
  const [addingNew, setAddingNew] = useState(false);

  const dispatch = useDispatch();
  const { tags } = useSelector((state) => state.tag);
  const message = useSelector((state) => state.message);
  const { services } = useSelector((state) => state.service);
  const { quotes, totalPages,quoteService } = useSelector((state) => state.quote);
  console.log("quote:",quoteService)

    const validationSchema = Yup.object({
      name: Yup.string().required("Name is required"),
      tag: Yup.string().required("Tag is required"),
      code: Yup.string().required("Code is required"),
      service_id: Yup.string().required("Service is required"),
      template_id: Yup.string().required("Template is required"),
    });
  
    const formik = useFormik({
      initialValues: {
        name: "", 
        tag: "", 
        code: "", 
        status: true, 
        template_id:"", 
        service_id:""
      },
      validationSchema,
      onSubmit: (values) => {
        console.log("values", values);
        dispatch(setLoading(true)); 
        if (isEditing) {
          if (values._id) {
            dispatch(updateTemplate({ id: values._id, formData: values }))
            .then(()=>{
              dispatch(setLoading(false));
              formik.resetForm();
              navigate(-1);
            })
            .catch(() => {
              dispatch(setLoading(false));
            });
          } else {
            console.error('Template ID is missing');
          }
        } else {
        dispatch(addTemplate(values))
        .then(()=>{
          dispatch(setLoading(false));
          formik.resetForm();
          navigate(-1);
        })
        .catch(() => {
          dispatch(setLoading(false));
        });
        }
      },
    });

    console.log("values", formik.values);

  useEffect(() => {
    if (message?.message) {
      toast(message.message);
      dispatch(clearMessage());
    }
  }, [message, dispatch]);

  useEffect(() => {
    dispatch(fetchTags());
    dispatch(getQuote())
    dispatch(fetchService());
  }, [dispatch]);
  

  useEffect(() => {
    if (isEditing && id) {
      dispatch(setLoading(true));
      dispatch(fetchTemplatesById(id))
      .then(() => {
        dispatch(setLoading(false));
      })
      .catch(() => {
        dispatch(setLoading(false));
      });
    }
  }, [dispatch, isEditing, id]);

  const {selectedTemplate} = useSelector((state) => state.template); 

  console.log("sel:",selectedTemplate)

  useEffect(() => {
    if (isEditing && selectedTemplate) {
      formik.setValues({
        _id:selectedTemplate?._id,
        name:selectedTemplate?.name,
        code: selectedTemplate?.codeContent, 
        tag: selectedTemplate.tag ? selectedTemplate.tag._id : "",
        status:selectedTemplate?.status,
        template_id:selectedTemplate?.template_id,
        service_id:selectedTemplate?.service_id
      });
      handleTemplate(selectedTemplate?.service_id );

    }

  }, [selectedTemplate, isEditing]); 
  
  useEffect(() => {
    const iframe = document.getElementById("myframe").contentWindow.document;
    iframe.open();
    iframe.write(formik.values.code);
    iframe.close();
  }, [formik.values.code]);

  const handleDialogOpen = useCallback(() => {
    setDialogOpen(true)
  }, []);

  const handleDialogClose = useCallback(() => {
    setDialogOpen(false);
    setAddingNew(false);
  }, []);

  const handleAddNewTag = useCallback(() => {
    if (newTag.trim()) {
      dispatch(addTag({ name: newTag }))
        .then(() => {
          dispatch(fetchTags());
          setNewTag("");
          setAddingNew(false);
        })
        .catch((error) => {
          console.error("Error adding tag:", error);
        });
    } else {
      window.alert("Tag is required");
    }
  }, [dispatch, newTag]);

  const handleTemplate = useCallback((serviceId) => {
      dispatch(setLoading(true));
        dispatch(getQuoteByServiceId({q_id: serviceId}))
          .then(() => {
            dispatch(setLoading(false));
          })
          .catch(() => {
            dispatch(setLoading(false));
          });
  }, []);

  return (
    <div className="content">
      <Box sx={{ padding: 2 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems:'center', mb: 2}}>
          <Typography variant="h4">{isEditing ? "Edit Template" : "Add Template"}</Typography>
          <Button
            variant="contained"
            color="success"
            sx={{
              display: "flex",
              alignItems: "center",
              "&:hover": { backgroundColor: "#2FB354" },
            }}
            onClick={handleDialogOpen}
          >
            Save
          </Button>
        </Box>

        <Box >
        <Grid container spacing={2}>
        <Grid size={6}>
        <RunCodeEditor
         template={formik.values}
         setTemplate={formik.setValues}/>
        </Grid>
        <Grid size={6}>
        <iframe
            id="myframe"
            title="HTML Preview"
            style={{
              width: "100%",
              height: "500px",
              border: "1px solid #333",
              overflow: "auto",
              borderRadius: "10px",
            }}
          />
        </Grid>
        </Grid>
        </Box>
      </Box>

      <Dialog open={dialogOpen} onClose={handleDialogClose} fullWidth>
      <form onSubmit={formik.handleSubmit}>
        <DialogTitle>{isEditing ? "Edit Template" : "Save Template"}</DialogTitle>
        <DialogContent>
        <FormControl fullWidth sx={{ mb: 2 }}>
                        <FormLabel>Service Name *</FormLabel>
                        <Autocomplete
                          disablePortal
                          options={services}
                          fullWidth
                          getOptionLabel={(option) => option.name}
                          value={
                            services.find(
                              (option) => option._id === formik.values.service_id
                            ) || null
                          }
                          onChange={(event, newValue) => {
                            console.log(newValue)
                            formik.setFieldValue("service_id", newValue?._id || null);
                            handleTemplate(newValue?._id );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select Service"
                              onBlur={formik.handleBlur}
                              error={formik.touched.service_id && Boolean(formik.errors.service_id)}
                              helperText={formik.touched.service_id && formik.errors.service_id}
                            />
                          )}
                        />
          </FormControl>
          <FormControl fullWidth sx={{ mb: 2 }}>
                        <FormLabel>Template Name *</FormLabel>
                        <Autocomplete
                          disablePortal
                          options={quoteService}
                          fullWidth
                          getOptionLabel={(option) => option.templateName}
                          value={
                            quotes.find(
                              (option) => option._id === formik.values.template_id
                            ) || null
                          }
                          onChange={(event, newValue) => {
                            formik.setFieldValue("template_id", newValue?._id || null);
                           

                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select Template"
                              onBlur={formik.handleBlur}
                              error={formik.touched.template_id && Boolean(formik.errors.template_id)}
                              helperText={formik.touched.template_id && formik.errors.template_id}
                            />
                          )}
                        />
                      </FormControl>
          <FormControl fullWidth margin="normal">
            <FormLabel>Showcase Name *</FormLabel>
            <TextField
            id="name"
                  name="name"
                  variant="outlined"
                  fullWidth
             placeholder="Enter Showcase Name" 
             value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.name && Boolean(formik.errors.name)}
                  helperText={formik.touched.name && formik.errors.name}
             />
          </FormControl>

          <FormControl fullWidth margin="normal">
            <FormLabel>Tag</FormLabel>
            {addingNew ? (
              <Box display="flex" gap={2}>
                <TextField value={newTag} onChange={(e) => setNewTag(e.target.value)} placeholder="Enter new tag" fullWidth />
                <Button variant="contained" color="success" sx={{ "&:hover": { backgroundColor: "#2FB354" } }} onClick={handleAddNewTag}>
                  Add
                </Button>
                <Button color="error"  onClick={() => {
                setAddingNew(false); 
                setNewTag("");
               }} >
               Cancel
              </Button>
              </Box>
            ) : (
              <Select
              id="tag"
                name="tag"
                variant="outlined"
                placeholder="Select Tag"
                value={formik.values.tag}
                onChange={formik.handleChange}
                fullWidth
                onBlur={formik.handleBlur}
                  error={formik.touched.tag && Boolean(formik.errors.tag)}
                  helperText={formik.touched.tag && formik.errors.tag}
              >
                {tags?.filter((item) => item && item._id).map((item, index) => (
                  <MenuItem key={index} value={item._id}>
                    {item.name}
                  </MenuItem>
                ))}
                <MenuItem value="createNew" onClick={() => setAddingNew(true)}>
                  + Create New
                </MenuItem>
              </Select>
            )}
          </FormControl>

        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="error">
            Cancel
          </Button>
          <Button type="submit" variant="contained" color="success" sx={{ "&:hover": { backgroundColor: "#2FB354" } }}>
            Save
          </Button>
        </DialogActions>
        </form> 
      </Dialog>

    </div>
  );
};

export default CodeEditor;
